import { forwardRef } from "react";
import { cx } from "../../utils";

const base =
  "w-full rounded-lg border bg-white text-sm text-ink-900 shadow-sm transition-colors " +
  "placeholder:text-ink-400 hover:border-ink-300 " +
  "focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-500/20 " +
  "disabled:cursor-not-allowed disabled:bg-ink-50 disabled:text-ink-500";

const Input = forwardRef(({ className = "", invalid, ...rest }, ref) => (
  <input
    ref={ref}
    aria-invalid={invalid || undefined}
    className={cx(base, "h-10 px-3", invalid ? "border-rose-400" : "border-ink-200", className)}
    {...rest}
  />
));
Input.displayName = "Input";

export const Textarea = forwardRef(({ className = "", invalid, ...rest }, ref) => (
  <textarea
    ref={ref}
    aria-invalid={invalid || undefined}
    className={cx(
      base,
      "min-h-[6.5rem] px-3 py-2.5 leading-6",
      invalid ? "border-rose-400" : "border-ink-200",
      className,
    )}
    {...rest}
  />
));
Textarea.displayName = "Textarea";

export const Select = forwardRef(({ className = "", children, ...rest }, ref) => (
  <select
    ref={ref}
    className={cx(base, "h-10 border-ink-200 px-3 pr-8 cursor-pointer", className)}
    {...rest}
  >
    {children}
  </select>
));
Select.displayName = "Select";

export const Label = ({ htmlFor, children, hint, required }) => (
  <label htmlFor={htmlFor} className="flex items-center gap-1.5 text-sm font-medium text-ink-800">
    {children}
    {required && <span className="text-rose-500">*</span>}
    {hint && <span className="font-normal text-ink-400">{hint}</span>}
  </label>
);

export default Input;
